import React, { useEffect, useState } from "react";
import { StaticImage } from "gatsby-plugin-image";

// Import components
import Canvases from "./canvases";
import Prints from "./prints";
import The from "./the";

// Import animation
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

// Import styles
import "./styles/products.scss";

// Import bootstrap
import { Container, Row, Tab, Tabs } from "react-bootstrap";

const Products = () => {
  const { ref, inView } = useInView({
    threshold: 0,
  });

  const variants = {
    hidden: { opacity: 1, y: 0 },
    visible: { opacity: 0, y: "100px" },
  };

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (inView) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [inView]);

  return (
    <section id="the-shop" className="products" inView={inView}>
      <StaticImage
        className="left-flower  fade-in-slow"
        src="../assets/images/flowers-left.png"
        alt="A collection of flowers."
      />
      <motion.div
        ref={ref}
        animate={isVisible ? "hidden" : "visible"}
        variants={variants}
      >
        <Container>
          <h1 className="shout">
            <The color="var(--paper)" />
            <br />
            Shop
          </h1>
          <Tabs defaultActiveKey="prints">
            <Tab eventKey="prints" title="Prints">
              <Row className="products-container">
                <Prints />
              </Row>
            </Tab>
            <Tab eventKey="canvases" title="Canvases">
              <Row className="products-container">
                <Canvases />
              </Row>
            </Tab>
          </Tabs>
        </Container>
      </motion.div>
      <StaticImage
        className="right-flower fade-in-slow"
        src="../assets/images/flowers-right.png"
        alt="A collection of flowers."
      />
    </section>
  );
};

export default Products;
